module.exports = __webpack_public_path__ + "static/img/news2.f4f662d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news/news2.png
// module id = GA13
// module chunks = 2